# Removes Text Ranges
# http://stackoverflow.com/a/3169849/616931

module.exports = ->

  if window.getSelection
    if window.getSelection().empty # Chrome
      window.getSelection().empty()
    else if window.getSelection().removeAllRanges  # Firefox
      window.getSelection().removeAllRanges()

  else if document.selection # IE?
    document.selection.empty()



// WEBPACK FOOTER //
// ./app/scripts/lib/util/removeAllRanges.coffee